import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FotoWareImportSettings } from "../../Model/recurringJobs/fotoWare/fotoWareImportSettings";
import { ModelService } from "../model.service";

@Injectable()
export class FotoWareImportSettingsService {
  constructor(public modelService: ModelService, private http: HttpClient) {
  }

  public getAll(): Observable<FotoWareImportSettings[]> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", this.modelService.loginService.currentCustomer.id)
    }
    return (this.http.get("api/FotoWareImportSettings/GetAll", options)) as any;
  }

  public update(setting: FotoWareImportSettings): Observable<FotoWareImportSettings> {
    return this.http.post<FotoWareImportSettings>("api/FotoWareImportSettings/Update", setting);
  }

  public create(setting: FotoWareImportSettings): Observable<FotoWareImportSettings> {
    setting.customerId = this.modelService.loginService.currentCustomer.id;
    return this.http.post<FotoWareImportSettings>("api/FotoWareImportSettings/Create", setting);
  }

  public delete(id: number): Observable<object> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("id", id.toString())
    }
    return this.http.delete<object>("api/FotoWareImportSettings/Delete", options);
  }

  public testConnection(id: number): Observable<{ success: boolean, message: string }> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("id", id.toString())
    }
    return this.http.get<{ success: boolean, message: string }>("api/FotoWareImportSettings/TestConnection", options);
  }

  public run(id: number, fullSync: boolean): Observable<object> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("id", id.toString()).append("fullSync", fullSync.toString())
    }
    return this.http.get<object>("api/FotoWareImportSettings/Run", options);
  }
}
